export const MOVING_WIDGET = 'moving-widget';
export const START_DRAGGING = 'start-dragging';
export const STOP_DRAGGING = 'stop-dragging';
export const REMOTE_MESSAGE_ACTIONS = {
  MOVING_WIDGET,
  START_DRAGGING,
  STOP_DRAGGING
};
export const isValidRemoteMessageAction = action => Object.values(REMOTE_MESSAGE_ACTIONS).includes(action);